export default {"src":"/_next/static/media/GLHerosIcon.91312119.svg","height":1276,"width":1108,"blurWidth":0,"blurHeight":0};